//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/ns-icon";
import { NsModal, NsButton } from "@nuskin/design-components";
import { RunConfigService, events, storage } from "@nuskin/ns-util";
import { getStack } from "@ns/ns-contentstack-lib";
import { CartService } from "@nuskin/ns-shop";

export default {
  name: "NsHomeMarketPurchasingOnlyBanner",
  components: { NsIcon, NsModal, NsButton },
  data() {
    return {
      message: null,
      loading: true,
      userCanAddToCart: true,
      modalTitle: null,
      modalMessage: null,
      modalClosed: false,
      modalButtonText: "OK"
    };
  },
  computed: {
    shouldDisplay() {
      // Show banner only if message is available and user cannot add to cart
      // Don't show until loading is complete
      return !this.loading && this.message && !this.userCanAddToCart;
    },
    shouldShowModal() {
      // Show modal only if modal content is available and user cannot add to cart
      // Don't show until loading is complete or if user has already seen the modal
      const hasSeenModal =
        localStorage.getItem(
          storage.metadata.VIEWED_HOME_MARKET_ONLY_RESTRICTION_MODAL.key
        ) === "true";
      return (
        !this.loading &&
        this.modalTitle &&
        this.modalMessage &&
        !this.userCanAddToCart &&
        !hasSeenModal &&
        !this.modalClosed
      );
    }
  },
  async mounted() {
    await Promise.all([
      this.loadContentstackContent(),
      this.checkUserCanAddToCart()
    ]);
    this.loading = false;

    // Subscribe to logout events to clear modal seen flag
    events.subscribe(events.authentication.LOGOUT, this.handleLogout);
  },
  beforeDestroy() {
    // Unsubscribe from logout events
    events.unsubscribe(events.authentication.LOGOUT, this.handleLogout);
  },
  methods: {
    async loadContentstackContent() {
      try {
        // Get current locale and environment from run config
        const runConfig = RunConfigService.getRunConfig();
        const country = runConfig.country;
        const language = runConfig.language;
        const envCode = RunConfigService.getEnvironmentCode();

        // Only proceed if all required configuration is available
        if (!country || !language || !envCode) {
          return;
        }

        // get content
        const stack = getStack(envCode);
        const [bannerContent] = await stack.getSingletonEntries({
          contentTypeUIDs: ["home_market_purchasing_only"],
          country: country,
          language: language,
          camelcase: true,
          mergeWithFallback: true
        });

        // Extract the banner message from the content
        this.message = bannerContent?.banner?.body || null;

        // Extract the modal content from the popup data
        this.modalTitle = bannerContent?.popUp?.title || null;
        this.modalMessage = bannerContent?.popUp?.message || null;
        this.modalButtonText = bannerContent?.popUp?.okButtonText || "OK";
      } catch (error) {
        console.error(
          "NsHomeMarketPurchasingOnlyBanner - Failed to load contentstack content:",
          error
        );
        // Don't show banner if content fails to load
      }
    },
    async checkUserCanAddToCart() {
      try {
        // Check if current user can add to cart
        this.userCanAddToCart = await CartService.canUserAddToCart();
      } catch (error) {
        console.error(
          "NsHomeMarketPurchasingOnlyBanner - Failed to check user cart permissions:",
          error
        );
        // Default to true (can add to cart) if check fails
        this.userCanAddToCart = true;
      }
    },
    handleModalClose() {
      // Mark modal as seen in localStorage
      localStorage.setItem(
        storage.metadata.VIEWED_HOME_MARKET_ONLY_RESTRICTION_MODAL.key,
        "true"
      );
      this.modalClosed = true;
    },
    handleLogout() {
      // Clear the modal seen flag when user logs out
      localStorage.removeItem(
        storage.metadata.VIEWED_HOME_MARKET_ONLY_RESTRICTION_MODAL.key
      );
    }
  }
};
